import styled from "styled-components";

const Container = styled.div`
  min-height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;

`

export default Container;